module.exports = __webpack_public_path__ + "img/star-filled.69517d14.svg";